import { RefreshCw } from "lucide-react";
import { useNavigate } from "react-router";

import { useOpenBudgetStatus, useSync, useSyncStatus } from "@/api/hooks";
import { Button } from "@/components/ui/button";
import { errorMessage } from "@/components/feedback/error-state";
import { formatRelative } from "@/lib/format";
import { cn } from "@/lib/utils";
import { useToast } from "@/state/toast";

export function SyncButton() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const openbudget = useOpenBudgetStatus();
  const status = useSyncStatus();
  const sync = useSync();

  const connected = openbudget.data?.status === "connected";
  const running = sync.isPending || !!status.data?.running;
  const lastSuccess = status.data?.lastSuccessAt ?? null;
  const title = !openbudget.data
    ? "Sincronizar"
    : !connected
      ? "OpenBudget no está conectado"
      : running
        ? "Sincronizando…"
        : `Última sincronización ${formatRelative(lastSuccess)}`;

  async function onClick() {
    if (!connected) {
      navigate("/ajustes?tab=openbudget");
      return;
    }
    try {
      const result = await sync.mutateAsync();
      if (result.run.status === "ok") toast("Sincronización completa", "success");
      else toast(`La sincronización terminó con error: ${result.run.error ?? "desconocido"}`, "error");
    } catch (error) {
      toast(errorMessage(error, "No se pudo sincronizar"), "error");
    }
  }

  return (
    <Button
      aria-label={title}
      className="relative h-12 w-12 rounded-full border-[#dfe3eb] dark:border-[#3f4548]"
      disabled={running}
      onClick={onClick}
      size="icon"
      title={title}
      variant="outline"
    >
      <RefreshCw className={cn("h-5 w-5", running && "animate-spin")} />
      {openbudget.data && !connected ? (
        <span aria-hidden="true" className="absolute right-3 top-3 h-2 w-2 rounded-full bg-[#ff3434]" />
      ) : null}
    </Button>
  );
}
